@if(matrixData) {
    <dx-pie-chart
        class="pie-chart"
        type="doughnut"
        palette="Harmony Light"
        [dataSource]="matrixData"
        [customizePoint]="customizeEmployeeChartPoint"
        (onPointClick)="onEmployeePointClick($event)"
        [legend]="{
            visible: true,
            verticalAlignment: 'bottom',
            horizontalAlignment: 'center',
            customizeText: customizeEmployeeChartText
        }"
    >
        <dxi-series argumentField="label" valueField="value">
        </dxi-series>
    </dx-pie-chart>
}
